export const setCookie = (name, value, days) => {
  let expires = "";
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  const cookieValue = typeof value === "object" ? JSON.stringify(value) : value;
  const serializedValue =
    value === null || value === undefined ? "" : String(cookieValue);
  document.cookie =
    name +
    "=" +
    encodeURIComponent(serializedValue) +
    expires +
    "; path=/; SameSite=Lax";
};

export const getCookie = (name) => {
  const nameEQ = name + "=";
  const ca = document.cookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) {
      const value = decodeURIComponent(c.substring(nameEQ.length, c.length));
      try {
        return JSON.parse(value);
      } catch (e) {
        return value;
      }
    }
  }
  return null;
};

export const removeCookie = (name) => {
  document.cookie = name + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
};

export const storage = {
  setItem: (key, value) => {
    const rememberMeCookie = getCookie("rememberme");
    const isRemembered =
      rememberMeCookie === true || rememberMeCookie === "true";

    let days = isRemembered ? 7 : null;

    if (key === "rememberme") {
      days = value === true || value === "true" ? 7 : null;
    }

    setCookie(key, value, days);
  },
  getItem: (key) => getCookie(key),
  removeItem: (key) => removeCookie(key),
  clear: () => {
    const cookies = document.cookie.split(";");
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i];
      const eqPos = cookie.indexOf("=");
      const name = eqPos > -1 ? cookie.substring(0, eqPos) : cookie;
      removeCookie(name.trim());
    }
  },
};

export const clearPageIdCookies = () => {
  removeCookie("current_pageid");
  removeCookie("present_pageid");
};
